import { useTranslation } from 'react-i18next';
import { Toolbar } from '@/shared/components/custom/toolbar/Toolbar';
import { MySummaryTasksTable } from '../components/MySummaryTasksTable';
import { MyOverdueTasksTable } from '../components/MyOverdueTasksTable';
import { MyTimeAnalysisSection } from '../components/MyTimeAnalysisSection';

export default function PersonalSummaryPage() {
  const { t } = useTranslation('personalSummary');

  return (
    <div className="space-y-6 p-4 md:p-6" data-testid="personal-summary-page">
      <Toolbar>
        <Toolbar.Info title={t('page.title')} description={t('page.subtitle')} />
        {/* Toolbar.Actions (e.g. "Exportar") intentionally omitted — no export endpoint in api.json yet. */}
      </Toolbar>

      <MySummaryTasksTable />
      <MyOverdueTasksTable />
      <MyTimeAnalysisSection />
    </div>
  );
}
